import PropTypes from 'prop-types'
import React from 'react'

import styles from './RatingLabelTooltip.scss'

import { Tooltip } from 'react-wot-bootstrap'
import { FormattedNumber } from 'react-intl'


import { BATTLES_ON_LEVEL, ELO_RATING_TEXT, RATING_POSITION } from 'helpers/i18n.jsx'
import { CLICK_TO_OPEN_LEADERBOARD } from 'containers/EloLeaderboard/constants.jsx'


export default class RatingLabelTooltip extends React.Component{
    static propTypes = {
        id: PropTypes.string.isRequired,
        elo: PropTypes.number.isRequired,
        position: PropTypes.number,
        vehicle_level: PropTypes.number.isRequired,
        show_leaderboard: PropTypes.bool,
    }

    render() {
        const eloRating = (
            <div className={styles.message}>
                {ELO_RATING_TEXT}
                {': '}
                <span className={styles.highlight}>
                    <FormattedNumber value={this.props.elo} />
                </span>
            </div>
        )
        const position = this.props.position && (
            <div className={styles.message}>
                {RATING_POSITION(
                    <span className={styles.highlight}>
                        <FormattedNumber value={this.props.position} />
                    </span>
                )}
            </div>
        )

        const footer = (
            <div className={styles.statusText}>
                <div className={styles.divider}/>
                {CLICK_TO_OPEN_LEADERBOARD}
            </div>
        )

        return (
            <Tooltip id={this.props.id}>
                <div className={styles.content}>
                    <div className={styles.subtitle}>
                        {BATTLES_ON_LEVEL(this.props.vehicle_level)}
                    </div>
                    {eloRating}
                    {this.props.show_leaderboard && position}
                    {this.props.show_leaderboard && footer}
                </div>
            </Tooltip>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/Stronghold/components/RatingLabelTooltip/RatingLabelTooltip.jsx